/* Cart Drawer Product Recommendations
   Custom file — survives theme updates.
   Re-link in snippets/cart-drawer.liquid if lost.
   Reuses the cart-notification-recommend section + quick-add assets. */

(function () {
  if (window.__cartDrawerRecommendInit) return;
  window.__cartDrawerRecommendInit = true;

  function render(wrapper, list) {
    var slot = wrapper.querySelector('.cart-drawer__recommend-slot');
    if (!slot) return;
    slot.innerHTML = '';
    slot.appendChild(list);
    wrapper.style.display = '';
  }

  // Try each product id in turn until one returns recommendations.
  // Shopify often returns an empty set for a given product (no related set
  // computed), so falling through the whole cart avoids an empty/hidden block.
  function tryIds(wrapper, ids, idx, expanded) {
    if (idx >= ids.length) {
      if (!expanded) {
        // Expand to every product currently in the cart, then keep trying.
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var merged = ids.slice();
            (cart.items || []).forEach(function (i) {
              var id = String(i.product_id);
              if (merged.indexOf(id) < 0) merged.push(id);
            });
            tryIds(wrapper, merged, idx, true);
          })
          .catch(function () { wrapper.style.display = 'none'; });
      } else {
        wrapper.style.display = 'none';
      }
      return;
    }

    var url = wrapper.dataset.baseUrl.replace('[product_id]', ids[idx]);
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var holder = document.createElement('div');
        holder.innerHTML = text;
        var list = holder.querySelector('.cart-notification__recommend-list');
        if (list && list.children.length) {
          render(wrapper, list);
        } else {
          tryIds(wrapper, ids, idx + 1, expanded);
        }
      })
      .catch(function () {
        tryIds(wrapper, ids, idx + 1, expanded);
      });
  }

  function populate(wrapper) {
    if (!wrapper || wrapper.__loaded) return;
    var pid = wrapper.dataset.productId;
    var slot = wrapper.querySelector('.cart-drawer__recommend-slot');
    if (!slot) return;
    wrapper.__loaded = true;
    var ids = pid ? [String(pid)] : [];
    tryIds(wrapper, ids, 0, false);
  }

  function scan() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !drawer.classList.contains('modal--open')) return;
    drawer.querySelectorAll('.cart-drawer__recommend').forEach(populate);
  }

  // Initial (cart may already have items on page load)
  if (document.readyState !== 'loading') {
    scan();
  } else {
    document.addEventListener('DOMContentLoaded', scan);
  }

  // Re-populate when the drawer opens or its contents re-render after a cart update.
  // The cart drawer re-renders .cart-drawer__inner on update, replacing the wrapper node
  // (which resets __loaded), so a debounced subtree observer covers both cases.
  var drawer = document.querySelector('cart-drawer');
  if (drawer) {
    var t;
    var observer = new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(scan, 120);
    });
    observer.observe(drawer, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }
})();
